import { BLOCKS, type Document as RichTextDocument } from '@contentful/rich-text-types'

export const faqData = [
  {
    question: `What does customer journey management mean?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Customer journey management is the process of mapping out, analyzing, and optimizing a person’s interactions
              with a brand, often with the goal of nudging them toward a conversion, strengthening their loyalty, or turning
              them into brand advocates. Customer journey management takes a look at each funnel stage and how different
              personas move through them – tracking and measuring each person’s engagement, actions, or points of friction to
              improve the overall user experience.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
  {
    question: `What customer channels can I track and manage in Journeys?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Journeys helps businesses orchestrate multi-step, multi-channel customer journeys at scale using real-time data. Businesses can connect Journeys to any tool in their tech stack to engage users on any channel, such as live chat, push notifications, paid and organic social media channels, and more.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `However, businesses can also connect Journeys to any tool in their tech stack to engage users on any channel,
              such as live chat, push notifications, paid and organic social media channels, and more.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
  {
    question: `Is journey mapping software the same as journey management software?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Usually, journey mapping tools take a retroactive look at the way a user has interacted with the business to
              understand the most common pain points or paths to acquisition.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `A customer journey management tool, however, takes a more strategic approach. It helps build and orchestrate
              customer journeys based on a person’s behavioral history, interests, job title, engagement rates and more.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Twilio Segment helps you do both of these things with Journeys. Businesses are able to unify their customer
              data into profiles, which help them map out, analyze, and iterate on the complete customer experience. It also
              offers teams the ability to activate this data by orchestrating multi-step customer experiences (across
              channels) that automatically adapt based on someone’s real-time behavior.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
]
